import React, { useState } from 'react';
import { Form as FinalForm, Field } from 'react-final-form';
import styled from '@emotion/styled';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore Child JSX components are throwing errors in consuming web-apps
import { Validations } from '../../util';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore Child JSX components are throwing errors in consuming web-apps
import { ButtonV2 } from '../../../Button';
import Message from '../../common/Message';
import { MessageContainer, FormLabel, State } from '../../form.styles';
import { Input } from '../InputFieldV3/InputFieldV3.styles';
import transformValidateProp from '../../util/transformValidateProp';

import styles from './mobileNumberButton.module.less';

export type MobileNumberButtonFormValues = {
  mobileNumber: string;
};

export type MobileNumberButtonProps = {
  onSubmit: (values: MobileNumberButtonFormValues) => Promise<void>;
};

const InputWrapper = styled.div<{ state?: State }>`
  display: flex;
  flex-direction: row;
  max-width: 250px;
`;

export const MobileButtonInput = styled(Input)`
  border-radius: 4px 0 0 4px;
  border-right: none;
`;

export const Placeholder = styled.div`
  height: 21px;
  width: 100%;
`;

export const SendButton = styled.button``;

const MobileNumberButton = ({ onSubmit }: MobileNumberButtonProps): JSX.Element => {
  const [sent, setSent] = useState(false);
  const buttonText = sent ? 'Done' : 'Send';

  const submit = (values: MobileNumberButtonFormValues) => {
    setSent(true);
    onSubmit(values).catch(() => undefined);
  };

  return (
    <FinalForm<MobileNumberButtonFormValues> onSubmit={submit}>
      {({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <FormLabel htmlFor="zMobileButtonInput">Mobile Number</FormLabel>
          <Field<string | undefined>
            validate={transformValidateProp([Validations.PHONE_US, Validations.REQUIRED])}
            type="input"
            name="mobileNumber"
          >
            {({ input, meta }) => {
              const hasError = meta && meta.touched && (meta.submitError || meta.error);
              const errorMessage = hasError ? meta.submitError || meta.error : '';
              return (
                <div>
                  <InputWrapper>
                    <MobileButtonInput
                      {...input}
                      type="tel"
                      placeholder="XXX-XXX-XXXX"
                      state={errorMessage ? 'error' : ''}
                      disabled={sent}
                      id="zMobileButtonInput"
                    />
                    <ButtonV2 type="submit" disabled={sent} className={styles.sendButton}>
                      {buttonText}
                    </ButtonV2>
                  </InputWrapper>
                  {errorMessage ? (
                    <MessageContainer>
                      <Message type="error" text={errorMessage} />
                    </MessageContainer>
                  ) : (
                    <Placeholder />
                  )}
                </div>
              );
            }}
          </Field>
        </form>
      )}
    </FinalForm>
  );
};

export default MobileNumberButton;
